import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export interface IForgotPasswordParams {
	UserName: string | null;
	EmailAddress: string | null;
}

const initialState = null;

export const { thunk: forgotPassword, slice: forgotPasswordSlice } = getThunkAndSlice<IForgotPasswordParams, null>({
	initialState,
	path: "/Account/ForgotPassword",
	method: "post",
});
